import { rootApi } from "../../api/rootApi";

export const cityMasterApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCityMasterList: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/city-master/list`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    addCityMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/city-master/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    updateCityMaster: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/city-master/update`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteCityMaster: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/city-master/delete`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    uploadCityMasterCsv: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/city-master/upload-csv`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useFetchCityMasterListMutation,
  useAddCityMasterMutation,
  useUpdateCityMasterMutation,
  useDeleteCityMasterMutation,
  useUploadCityMasterCsvMutation,
} = cityMasterApi;
